import { SET_DOCUMENT_MODE, USER_LOGOUT, DOCUMENT_LOADING } from 'src/actions/reduxConstants';
import { DocumentMode } from 'src/actions/documentMode';

interface DocumentModeState {
	mode: DocumentMode;
	loading?: boolean;
}

const initial_state: DocumentModeState = {
	mode: 'order',
	loading: false,
};

const document_mode_reducer = (state = initial_state, action: any): DocumentModeState => {
	switch (action?.type) {
		case SET_DOCUMENT_MODE:
			if (state?.mode === action?.payload) {
				return state;
			}
			return {
				...state,
				mode: action?.payload,
			};
		case DOCUMENT_LOADING:
			return {
				...state,
				loading: action?.payload,
			};
		case USER_LOGOUT:
			return { ...initial_state };
		default:
			return state;
	}
};

export default document_mode_reducer;

export const set_document_loading = (loading: boolean) => ({
	type: DOCUMENT_LOADING,
	payload: loading,
});
